import { useState } from 'react';
import { Page } from 'consts/BulkPaymentConst';

// 共通決済(一括)画面のページ遷移を管理するhook
export const useBulkPaymentPage = () => {
	const [page, setPage] = useState(Page.DEFAULT);
	const isDefault = () => {
		return Page.DEFAULT === page;
	};
	const isShowSavedCard = () => {
		return Page.SHOW_SAVED_CARD === page;
	};
	const isDeleteCard = () => {
		return Page.DELETE_CARD === page;
	};
	const isConfirm = () => {
		return Page.CONFIRM === page;
	};
	const isUnSupported = () => {
		return Page.UN_SUPPORTED === page;
	};
	const isServiceError = () => {
		return Page.SERVICE_ERROR === page;
	};

	return {
		page,
		setPage,
		isDefault,
		isShowSavedCard,
		isDeleteCard,
		isConfirm,
		isUnSupported,
		isServiceError,
	};
};
